import { SecurityInfo } from 'data/securityInfo/securityInfo.types';
import { WithAuditDetails, AuditDetails, Operation } from 'data/types';
import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';

export default function getSecurityInfoDataToSubmit(
  securityInfo: SecurityInfo,
  originalSecurityInfo: SecurityInfo | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): WithAuditDetails<SecurityInfo> {
  const body: WithAuditDetails<SecurityInfo> = {
    data: securityInfo,
  };

  let actionType = AuditActionType.SECURITY_INFO_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.SECURITY_INFO_EDIT;
    isEdit = true;
  }

  if (isAuditEnabled) {
    const auditDetails = getAuditDetails(
      isAuditEnabled,
      userId,
      userName,
      getAuditFieldInfo(securityInfo, null, isEdit, originalSecurityInfo),
      securityInfo.id,
      AuditService.SECURITY_INFO,
      actionType,
    );

    body.auditDetails = auditDetails as AuditDetails;
  }

  return body;
}
